export default class ContextMenuDefinition
{
    constructor(id, label, action, type = 'js', target = '_parent', disabled = false, dataBot = '') {
        this.id = id;
        this.label = label;
        this.action = action;
        this.type = type;
        this.target = target;
        this.disabled = disabled;
        this.metas = {};
        this.contextId = null;
        this.dataBot = dataBot;
    }

    build(row) {
        return {
            id: this.id,
            label: typeof this.label === 'function' ? this.label(row) : this.label,
            action: typeof this.action === 'function' ? this.action(row) : this.action,
            disabled: typeof this.disabled === 'function' ? this.disabled(row) : this.disabled,
            target: this.target,
            type: this.type,
            dataBot: this.dataBot,
        };
    }
}